export default {
  type: "python-dnd",
  layout: "layouts/uk-coding",
  components: [
    require("fixtures/components/instructions.json"),
    require("fixtures/components/python-dnd-editor.json"),
  ],
};
